<template>
    <div :class="cssClass">
        <input type="button" :class="cssClassButton" :value="i18n.t(props.text)" :disabled="props.disabled" />
    </div>
</template>
<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    interface IPropsButton {
        text?: string
        disabled?: boolean
        cssClass?: string
        cssClassButton?: string
    }

    const props = withDefaults(defineProps<IPropsButton>(), {
        text: '',
        disabled: false,
        cssClass: '',
        cssClassButton: '',
    })
</script>
